import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import * as localforage from 'localforage';



@Component({
  selector: 'app-config',
  templateUrl: './config.component.html',
  styleUrls: ['./config.component.scss']
})
export class ConfigComponent implements OnInit {

  public data:any = {
    hora_inicio:"13:00",
    horasJuego:5,
    cubrebocas:{
      n:30,
      win:[],
    },
    desc10:{
      n:40,
      win:[],
    },
    desc15:{
      n:40,
      win:[],
    },
  };
  public serial:string = "";
  public premios:any = [];
  @Output() public home: EventEmitter<any> = new EventEmitter;
  constructor(private cookieService: CookieService) { }

  ngOnInit() {

    localforage.getItem('game-history').then((value:string)=> {
      if(value){
        this.data = JSON.parse(value)
      }else{
        console.log("NO exists")
        let data = {
          hora_inicio:"13:00",
          horasJuego:5,
          cubrebocas:{
            n:30,
            win:[],
          },
          desc10:{
            n:40,
            win:[],
          },
          desc15:{
            n:40,
            win:[],
          },
        }
        localforage.setItem('game-history', JSON.stringify(data)).then((value)=>{
          // Do other things once the value has been saved.
          this.data = JSON.parse(value)
          console.log(JSON.parse(value));
        }).catch(function(err) {
            // This code runs if there were any errors
            console.log(err);
        });
      }
    }).catch(function(err) {
        // This code runs if there were any errors
        console.log(err);
    });
    const serial: boolean = this.cookieService.check('serial-number');
    if(serial){
      this.serial = this.cookieService.get('serial-number')
    }else{
      this.cookieService.set( 'serial-number','');
    }
  }
  goToHome(){
    this.home.emit(true);
  }
  guardar(){
    if(Number.isInteger(this.data.cubrebocas.n) && Number.isInteger(this.data.desc10.n) && Number.isInteger(this.data.desc15.n)){
      localforage.setItem('game-history', JSON.stringify(this.data)).then( (value) =>{
        // Do other things once the value has been saved.
        console.log("save")
        this.cookieService.set( 'serial-number',this.serial);
        this.home.emit(true);
      }).catch(function(err) {
          // This code runs if there were any errors
          console.log(err);
      });
    }else{
      alert("Por favor revisar que los datos ingresados sean correctos.")
    }
  }
}
